var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-breadcrumb',{attrs:{"routes":_vm.filterRoute},scopedSlots:_vm._u([{key:"itemRender",fn:function(ref){
var route = ref.route;
var routes = ref.routes;
return [(_vm.notLink(routes, route))?_c('span',[_vm._v("\n        "+_vm._s(route.meta.title)+"\n      ")]):_c('span',[_vm._v(_vm._s(route.meta.title))])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-256de100","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/breadcrumb.vue
// module id = null
// module chunks = 